import { REGEXP_ONLY_DIGITS } from 'input-otp';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/components/ui/input-otp';
import {
  FormItem,
  FormMessage,
  FormControl,
  FormLabel,
  FormDescription,
} from '@/components/ui/form';
import { InputElementBase } from '../utils/types';

export default function VerifyEmailInput({
  disabled,
  name,
  onChange,
  ref,
  value,
  maxLength,
  label,
  description,
  pattern = REGEXP_ONLY_DIGITS,
}: Exclude<
  InputElementBase,
  'icon' | 'type' | 'className' | 'placeholder' | 'className'
> & {
  maxLength: number;
  pattern?: string;
}) {
  return (
    <FormItem ref={ref}>
      {label && <FormLabel>{label}</FormLabel>}
      <FormControl>
        <InputOTP
          maxLength={maxLength}
          pattern={pattern}
          name={name}
          value={value ? String(value) : undefined}
          onChange={onChange}
          disabled={disabled}
        >
          <InputOTPGroup>
            {Array.from(new Array(maxLength)).map((_, index) => (
              <InputOTPSlot key={`otp_input_slot_${index}`} index={index} />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage className="text-center" />
    </FormItem>
  );
}
